import type { SVGProps } from 'react';
const SvgPig = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path
      fillRule="evenodd"
      d="m31.79 22.947-.456-2.493 3.166-2.117a3.96 3.96 0 0 0-3.957 0C21.777 7.592 9.766 9.65 5.729 14.16c-2.354 2.533-.653 7.025-.376 8.47l1.98 5.936H9.31l.396-5.58c2.908 1.681 6.846 1.444 11.1.633l.376 2.968v1.979h1.979v-1.98l.514-3.106 3.285 2.078 3.008.257 1.741.337 1.148-1.544z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPig;
